// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Bar","type":"styles_type__1b1QH","choices":"styles_choices__jP4Fh"};